var map = {
	"./0x44fa8e6f47987339850636f88629646662444217.png": "ZPE6",
	"./0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb.png": "9jLW",
	"./0xb7D311E2Eb55F2f68a9440da38e7989210b9A05e.png": "X80Q",
	"./0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d.png": "owtD",
	"./eth.png": "DAIb",
	"./xdai.png": "9SeA"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "k4Oi";